import httpService from "./httpService.js"

export const getAllDiscountsService = () => {
    return httpService("/shop_admin/coupon_admin_panel/", "get");
}

export const addNewDiscountService = (data) => {
    return httpService("/shop_admin/coupon_admin_panel/", "post", data);
}

export const editDiscountService = (discountCode, data) => {
    return httpService(`/shop_admin/coupon_admin_panel/${discountCode}/`, "patch", data);
}